import { send } from 'server';

export const getTimeSlotExclusions = () => send({
    ID: 35811,
    errorLevel: 1,
    responses: [35812, 35813],
    description: 'Get TimeSlot Exclusions'
});

export const setTimeSlotExclusions = ({ revision, timeSlotExclusions }) => send({
    ID: 35814,
    errorLevel: 1,
    responses: [35815, 35816],
    description: 'Set TimeSlot Exclusions',
    revision,
    timeSlotExclusions
});
